import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { ChromeAppWrapperView } from "#webapp/src/util/chrome-extension.util";
import React from "react";
import { useSelector } from "react-redux";
import { ChromeNavMenu, IProps as IMenuContainer } from "../ChromeNavMenu";
import { ChromeNavBackBtn } from "./ChromeNavBackBtn";

interface IContainer extends IMenuContainer {
  label: string | JSX.Element;
  labelStyle?: React.CSSProperties;
  backDestination?: ChromeAppWrapperView;
  onBack?: () => void;
  menuItems?: { [name: string]: () => void };
  hideBackBtn?: boolean;
}

export const ChromeNavGeneric = ({
  label,
  labelStyle,
  backDestination,
  hideBackBtn,
  onBack,
  settings,
  editTeam,
  feedback,
}: IContainer) => {
  const mode = useSelector((state: IReduxState) => state.webExtension.mode);
  return (
    <div className="cw-flex cw-items-center cw-justify-between cw-h-[60px]">
      {!hideBackBtn ? <ChromeNavBackBtn backDestination={backDestination} onBack={onBack} /> : ""}
      <div className="cw-heading-xl" style={labelStyle}>
        {label}
      </div>
      {mode === "extension" ? (
        <ChromeNavMenu settings={settings} editTeam={editTeam} feedback={feedback} />
      ) : (
        <span />
      )}
    </div>
  );
};
